import replace from "lodash/replace";
import startsWith from "lodash/startsWith";
import sumBy from "lodash/sumBy";
import * as React from "react";
import NumberInput from "react-phone-number-input/input";
import { hasText } from "utils/helpers";

import { Input } from "./Input";

// export type Props = {
//   $hasError?: boolean,
//   disabled?: boolean,
//   inputId?: string,
//   maxLength?: number,
//   name?: string,
//   onBlur?: Function,
//   onChange?: Function,
//   placeholder?: string,
//   style?: { [string]: string | number },
//   value?: string,
// };

export function buildPhoneNumberValue(inputValue?: ?string): ?string {
  const value = inputValue || "";
  if (!hasText(value)) return undefined;
  if (value?.length === 10 && value?.[0] !== "1") return `+1${value}`;
  if (value?.[0] === "+") return value;

  return `+${value}`;
}

function calculateMaxLength(currentValue: string) {
  const initialCount = startsWith(currentValue, "1 ") ? 0 : -1;
  const notNumberCount = sumBy(currentValue, (char) =>
    char !== " " && Number?.isInteger(+char) ? 0 : 1,
  );
  return initialCount + 11 + notNumberCount;
}

function PhoneInput({
  $hasError,
  disabled,
  maxLength,
  inputId,
  name,
  onBlur,
  onChange = () => undefined,
  placeholder,
  style,
  value = "",
  ...props
}) {
  const inputRef = React.useRef<null | HTMLInputElement>(null);

  const inputValue = buildPhoneNumberValue(value);

  const maxLengthValue =
    maxLength ?? calculateMaxLength(inputRef?.current?.value || "");

  const handleChange = (value: string) => {
    if (disabled) return;
    const replaced = replace(value, /\D/g, "");

    if ((replaced?.length ?? 0) > 12) {
      const sliced = replaced?.slice?.(0, 11);
      return onChange(sliced);
    }
    return onChange(replaced);
  };

  return (
    <NumberInput
      country="US"
      hasError={$hasError}
      id={inputId || name}
      inputComponent={Input}
      maxLengthValue={maxLengthValue}
      name={name}
      onBlur={onBlur}
      onChange={handleChange}
      placeholder={placeholder}
      ref={inputRef}
      style={style}
      trueValue={value}
      value={inputValue}
      {...props}
    />
  );
}

export default PhoneInput;
